import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Trash2 } from 'lucide-react';
import api from '../api';

const CategoryDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const isCreateMode = !id || id === 'create';

    const [formData, setFormData] = useState({
        name: '',
        code: '',
        type: 'JOB_FIELD',
        status: true
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isCreateMode && id) {
            const fetchCategory = async () => {
                try {
                    const response = await api.get(`/categories/${id}`);
                    setFormData(response.data);
                } catch (error) {
                    console.error("Error fetching category:", error);
                }
            };
            fetchCategory();
        }
    }, [id, isCreateMode]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            if (isCreateMode) {
                await api.post('/categories', formData);
            } else {
                await api.put(`/categories/${id}`, formData);
            }
            navigate('/categories');
        } catch (error) {
            console.error("Error saving category:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Bạn có chắc chắn muốn xóa danh mục này?')) {
            try {
                await api.delete(`/categories/${id}`);
                navigate('/categories');
            } catch (error) {
                console.error("Error deleting category:", error);
            }
        }
    };

    return (
        <div className="category-detail">
            <div className="page-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button
                        onClick={() => navigate('/categories')}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    >
                        <ArrowLeft size={24} />
                    </button>
                    <h1 className="page-title">{isCreateMode ? 'Tạo danh mục mới' : 'Chi tiết danh mục'}</h1>
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                    {!isCreateMode && (
                        <button
                            onClick={handleDelete}
                            style={{
                                background: '#FFEBEE',
                                border: 'none',
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                color: '#D32F2F',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Trash2 size={20} />
                        </button>
                    )}
                    <button className="btn-primary" onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Đang xử lý...' : 'Xác nhận'}
                    </button>
                </div>
            </div>

            <div className="form-section">
                <h3 className="section-title">Thông tin danh mục</h3>
                <div className="form-group">
                    <label>Tên danh mục</label>
                    <input
                        type="text"
                        className="form-input"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label>Mã danh mục</label>
                    <input
                        type="text"
                        className="form-input"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                    />
                </div>
                <div className="form-group">
                    <label>Loại danh mục</label>
                    <select
                        className="form-select"
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                    >
                        <option value="JOB_FIELD">Lĩnh vực</option>
                        <option value="LOCATION">Địa điểm</option>
                        <option value="JOB_TYPE">Hình thức làm việc</option>
                        <option value="POSITION">Vị trí</option>
                        <option value="EDUCATION">Trình độ học vấn</option>
                        <option value="EXPERIENCE">Kinh nghiệm</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>
                        <input
                            type="checkbox"
                            name="status"
                            checked={formData.status}
                            onChange={handleChange}
                            style={{ marginRight: '8px' }}
                        />
                        Hoạt động
                    </label>
                </div>
            </div>

            <style>{`
        .category-detail {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .form-section {
          background: white;
          border-radius: 8px;
          padding: 24px;
          border: 1px solid #E0E0E0;
        }
        .section-title {
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 16px;
          color: #1A1A1A;
        }
        .form-group {
          margin-bottom: 16px;
        }
        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #1A1A1A;
        }
        .form-input, .form-select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #E0E0E0;
          border-radius: 6px;
          font-size: 14px;
          background: #F5F7FA;
          box-sizing: border-box;
        }
      `}</style>
        </div>
    );
};

export default CategoryDetail;
